import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../utils/animations';

const PageAnimationWrapper = ({ children, className = "" }) => {
  return (
    <motion.div 
      className={`min-h-screen w-full ${className}`}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
};

export default PageAnimationWrapper;
